import { Star } from "lucide-react";
import { FadeUp, SectionHead } from "./Motion";

const REVIEWS = [
  { name: "Priya Raghavan", text: "The Mysore Masala Dosa transported me straight back to Bangalore. Crackling edges, perfect spice, chutneys clearly made fresh that morning.", tag: "Google Review" },
  { name: "James Whitfield", text: "Ordered catering for our office Diwali party — 80 people, live dosa counter, zero complaints. The team was professional from quote to cleanup.", tag: "Corporate Catering" },
  { name: "Ananya Krishnan", text: "Finally, a place that does pesarattu and gongura dosa right. The filter coffee alone is worth the drive from Princeton.", tag: "Google Review" },
  { name: "Rajesh Mehta", text: "We booked them for my daughter's birthday. Banana-leaf service, beautiful presentation, and the gulab jamun disappeared in minutes.", tag: "Birthday Catering" },
  { name: "Sarah O'Brien", text: "I'm new to South Indian food and the staff walked me through the whole menu. The Mini Tiffin is the perfect tasting flight. We're regulars now.", tag: "Google Review" },
  { name: "Venkata Subramanian", text: "Authentic, fast, and consistent. The rava onion-chilli dosa is the best I've had outside of Chennai. Jain options handled with real care.", tag: "Google Review" },
];

const Stars = () => (
  <div className="flex gap-1" aria-label="5 star rating">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={14} className="fill-gold text-gold" />
    ))}
  </div>
);

const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="border-y border-white/8 bg-surface/40">
    <div className="mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
      <SectionHead
        index="08"
        kicker="Reviews"
        title={<>Word around <em className="italic text-gold">Edison</em></>}
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <FadeUp key={r.name} delay={(i % 3) * 0.1}>
            <blockquote
              data-testid={`review-card-${i}`}
              className="glass flex h-full flex-col justify-between gap-8 rounded-2xl p-8 transition-transform duration-500 hover:-translate-y-1.5"
            >
              <div>
                <Stars />
                <p className="mt-5 font-serif text-xl leading-relaxed text-white/85">“{r.text}”</p>
              </div>
              <footer className="flex items-center justify-between">
                <span className="text-sm font-medium text-white">{r.name}</span>
                <span className="text-[10px] uppercase tracking-[0.22em] text-gold/80">{r.tag}</span>
              </footer>
            </blockquote>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default Reviews;
